module.exports = __webpack_public_path__ + "img/icon_map_entity_6.e6d25a47.png";